import Calendar from "@/utils/calendar";

export const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 50,
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    // {
    //     title: '批次号编号',
    //     dataIndex: 'pkgCode',
    //     key: 'pkgCode',
    // },
    {
        title: '店铺名',
        dataIndex: 'customerShopName',
        key: 'customerShopName',
    },
    {
        title: '商品SKU',
        dataIndex: 'shopProductSku',
        key: 'shopProductSku',
    },
    {
        title: '商品图片',
        dataIndex: 'productImg',
        key: 'productImg',
        scopedSlots: {
            customRender: 'productImgAction'
        }
    },
    {
        title: '商品数量',
        dataIndex: 'totalChecked',
        key: 'totalChecked',
    },
    {
        title: '冻结数量',
        dataIndex: 'totalFreezed',
        key: 'totalFreezed',
    },
    // {
    //     title: '所在库区',
    //     dataIndex: 'kuQu',
    //     key: 'kuQu',
    //     customRender: (text, record, index) => {
    //         return {0: '异常区', 1: '次品区', 2: '成品区'}[1]
    //     },
    // },
    {
        title: '订单来源',
        dataIndex: 'systemSource',
        key: 'systemSource',
        customRender: (text, record, index) => {
            return {1: 'D2C', 2: 'B2B'}[text]
        },
    },
    // {
    //     title: '入库时间',
    //     dataIndex: 'time',
    //     key: 'time',
    //     customRender: (text, record, index) => {
    //         return Calendar.d1(text)
    //     },
    // },
    // {
    //     title: '上架人',
    //     dataIndex: 'name',
    //     key: 'name',
    // },
]